import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormrenderService } from '../../formrender/formrender.service';

@Component({
  selector: 'app-documentactivitylog',
  templateUrl: './documentactivitylog.component.html',
  styleUrls: ['./documentactivitylog.component.css']
})
export class DocumentactivitylogComponent implements OnInit {
  @Input() documentIdInput: number;
  @Input() formConfigIdInput: number;
  logList: any = [];
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  constructor(private formrenderService: FormrenderService) { }
  ngOnInit() {
    this.formrenderService.getDocumentActivityLog(this.formConfigIdInput, this.documentIdInput).subscribe(res => {
      //console.log(res);
      if (res != undefined)
        this.logList = res;
    })
  }
  //key: string = 'firstname'; //set default
  key: string = 'date';
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

}
